import businessIcon from "@assets/images/bussiness_icon.svg";
import {
  Box,
  Card,
  CardContent,
  Container,
  TextField,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CardSpacer from "@saleor/components/CardSpacer";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { FormChange } from "@saleor/hooks/useForm";
import React from "react";
import { useIntl } from "react-intl";

import { BusinessPageFormData } from "./../../views/BusinessDetailsPage";
const useStyles = makeStyles(
  {
    MuiFormHelperText: {
      color: "#EC5D77",
      fontSize: "0.75rem",
      margin: "6px 14px"
    },
    agreement: {
      float: "left",
      fontSize: "13px",
      margin: "12px 0",
      marginLeft: "-5px"
    },
    agreement_box: {
      display: "flex",
      flexDirection: "row"
    },
    agreement_checkbox: {
      marginRight: "5px",
      width: "40px"
    },
    bussinessIcon: {
      float: "left",
      margin: "-5px 10px 0 5px",
      width: "25px"
    },
    cardContent: {
      width: "100%"
    },
    categories: {
      fontSize: "18px",
      margin: "0 0 20px",
      position: "relative",
      top: "15px"
    },
    err_fields: {
      backgroundColor: "#393636",
      color: "#fff",
      left: 0,
      padding: "10px 20px",
      position: "absolute",
      right: 0,
      top: "-40px",
      width: "100%"
    },
    formControl: {
      margin: "-5px 0 0",
      width: "100%"
    },
    formControlSelect: {
      "& .MuiSelect-select:focus, &.Mui-focused, &:hover": {
        backgroundColor: "transparent"
      },
      backgroundColor: "transparent"
    },
    formHelper: {
      fontSize: "11px",
      margin: "3px 0 0",
      textAlign: "right"
    },
    formLabel: {
      color: "#0030FF",
      fontSize: "16px",
      left: "0",
      position: "absolute",
      top: "-30px"
    },
    formSubmitBtn: {
      backgroundColor: "#011671",
      borderRadius: 0,
      color: "#fff",
      float: "right",
      fontSize: "12px",
      margin: "20px 0 0",
      padding: "2px 40px"
    },
    inputType: {
      paddingTop: "12px"
    },
    mainCard: {
      alignItems: "center",
      display: "flex",
      marginTop: "70px",
      padding: "10px 20px 50px",
      paddingBottom: "50px",
      position: "relative",
      width: "800px"
    },
    requiredAsterisk: {
      color: "#f00"
    },
    root: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      margin: "0 auto",
      maxWidth: 800,
      padding: 0
    }
  },
  { name: "BusinessDetailsPage" }
);
export interface BDFormData {
  name: string;
  legalName: string;
  tinNo: string;
  completeAddress: string;
  signatoryName: string;
  signatoryDesignation: string;
  signatoryEmail: string;
  signatoryMobileNo: string;
  bankName: string;
  bankAccountName: string;
  bankAccountNo: string;
  financeName: string;
  financeEmail: string;
  financeMobileNo: string;
  storeType: string;
}
export interface BusinessDetailsCardProps {
  data: BusinessPageFormData;
  onChange: FormChange;
  validations;
}

export const BusinessDetailsForm: React.FC<BusinessDetailsCardProps> = ({
  validations,
  data,
  onChange
}) => {
  const classes = useStyles({});
  const { err } = validations;
  const intl = useIntl();
  const storeTypes = [
    { label: "Food and Beverages", value: "FOOD_AND_BEVERAGES" },
    { label: "General Merchandise", value: "GENERAL_MERCHANDISE" },
    { label: "Grocery", value: "GROCERY" }
  ];
  return (
    <Container className={classes.root}>
      <Card className={classes.mainCard}>
        <Box className={classes.formLabel}>
          <img className={classes.bussinessIcon} src={businessIcon} /> Enter
          Your Business Details
        </Box>
        <CardContent className={classes.cardContent}>
          <Typography
            className={classes.categories}
            variant="h6"
            component="h6"
          >
            Business Information
          </Typography>
          <TextField
            label="Lease Name:"
            value={data.name || ""}
            name="name"
            onChange={onChange}
            fullWidth
            error={err.name ? true : false}
            helperText={err.name ? err.name : ""}
          />
          <CardSpacer />
          <TextField
            label="Company Name:"
            value={data.legalName || ""}
            name="legalName"
            onChange={onChange}
            fullWidth
            error={err.legalName ? true : false}
            helperText={err.legalName ? err.legalName : ""}
          />
          <CardSpacer />
          <SingleSelectField
            label={intl.formatMessage({
              defaultMessage: "Classification"
            })}
            onChange={onChange}
            choices={storeTypes}
            name="storeType"
            value={data.storeType || ""}
            error={err.storeType ? true : false}
          />
          {err.storeType ? (
            <p className={classes.MuiFormHelperText}>{err.storeType}</p>
          ) : (
            ""
          )}
          <CardSpacer />
          <TextField
            label="Tin No.:"
            value={data.tinNo || ""}
            name="tinNo"
            onChange={onChange}
            fullWidth
            error={err.tinNo ? true : false}
            helperText={err.tinNo ? err.tinNo : ""}
          />
          <CardSpacer />
          <TextField
            label="Complete Address:"
            value={data.completeAddress || ""}
            name="completeAddress"
            onChange={onChange}
            fullWidth
            error={err.completeAddress ? true : false}
            helperText={err.completeAddress ? err.completeAddress : ""}
          />
          <CardSpacer />

          <Typography
            className={classes.categories}
            variant="h6"
            component="h6"
          >
            Authorized Signatory
          </Typography>
          <TextField
            label="Signatory Name:"
            value={data.signatoryName || ""}
            name="signatoryName"
            onChange={onChange}
            fullWidth
            error={err.signatoryName ? true : false}
            helperText={err.signatoryName ? err.signatoryName : ""}
          />
          <CardSpacer />
          <TextField
            label="Signatory Designation:"
            value={data.signatoryDesignation || ""}
            name="signatoryDesignation"
            onChange={onChange}
            fullWidth
            error={err.signatoryDesignation ? true : false}
            helperText={
              err.signatoryDesignation ? err.signatoryDesignation : ""
            }
          />
          <CardSpacer />
          <TextField
            label="Signatory Email:"
            value={data.signatoryEmail || ""}
            name="signatoryEmail"
            onChange={onChange}
            fullWidth
            error={err.signatoryEmail ? true : false}
            helperText={err.signatoryEmail ? err.signatoryEmail : ""}
          />
          <CardSpacer />
          <TextField
            label="Signatory Mobile No.:"
            value={data.signatoryMobileNo || ""}
            name="signatoryMobileNo"
            onChange={onChange}
            fullWidth
            error={err.signatoryMobileNo ? true : false}
            helperText={err.signatoryMobileNo ? err.signatoryMobileNo : ""}
          />
          <CardSpacer />

          <Typography
            className={classes.categories}
            variant="h6"
            component="h6"
          >
            Bank Details
          </Typography>

          <TextField
            label="Bank Name:"
            value={data.bankName || ""}
            name="bankName"
            onChange={onChange}
            fullWidth
            error={err.bankName ? true : false}
            helperText={err.bankName ? err.bankName : ""}
          />
          <CardSpacer />
          <TextField
            label="Bank Account Name:"
            value={data.bankAccountName || ""}
            name="bankAccountName"
            onChange={onChange}
            fullWidth
            error={err.bankAccountName ? true : false}
            helperText={err.bankAccountName ? err.bankAccountName : ""}
          />
          <CardSpacer />
          <TextField
            label="Bank Account No.:"
            value={data.bankAccountNo || ""}
            name="bankAccountNo"
            onChange={onChange}
            fullWidth
            error={err.bankAccountNo ? true : false}
            helperText={err.bankAccountNo ? err.bankAccountNo : ""}
          />
          <CardSpacer />

          <Typography
            className={classes.categories}
            variant="h6"
            component="h6"
          >
            Finance Contact Details
          </Typography>
          <TextField
            label="Finance Name:"
            value={data.financeName || ""}
            name="financeName"
            onChange={onChange}
            fullWidth
            error={err.financeName ? true : false}
            helperText={err.financeName ? err.financeName : ""}
          />
          <CardSpacer />
          <TextField
            label="Finance Email:"
            value={data.financeEmail || ""}
            name="financeEmail"
            onChange={onChange}
            fullWidth
            error={err.financeEmail ? true : false}
            helperText={err.financeEmail ? err.financeEmail : ""}
          />
          <CardSpacer />
          <TextField
            label="Finance Mobile No.:"
            value={data.financeMobileNo || ""}
            name="financeMobileNo"
            onChange={onChange}
            fullWidth
            error={err.financeMobileNo ? true : false}
            helperText={err.financeMobileNo ? err.financeMobileNo : ""}
          />
        </CardContent>
      </Card>
    </Container>
  );
};
export default BusinessDetailsForm;
